var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-flex',[_c('h3',[_vm._v("Pagina no encontrada")]),_c('v-btn',{attrs:{"flat":"","color":"primary","to":"/"}},[_vm._v("Home")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }